// recon-other-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'rco.age.d0to30': '0–30 dager',
  'rco.age.d31to60': '31–60 dager',
  'rco.age.d61to90': '61–90 dager',
  'rco.age.over90': 'Over 90 dager',
  'rco.age.noDate': 'Uten dato',
  'rco.noText': 'Uten tekst',
  'rco.type.liability': 'Gjeld',
  'rco.type.asset': 'Eiendel',
  'rco.check.specVsLedger': 'Spesifiserte poster mot hovedboken',
  'rco.check.notFullySpecified': 'Saldoen er ikke fullt spesifisert',
  'rco.check.sumsToLedger': 'Summerer seg til hovedboken',
  'rco.check.older90': 'Poster eldre enn 90 dager',
  'rco.check.noCounterparty': 'Poster uten identifisert motpart',
  'rco.check.unusualSign': 'Poster med uvanlig fortegn',
  'rco.check.noMovement': 'Poster uten bevegelse i perioden',
  'rco.check.manualAtPeriodEnd': 'Manuelle posteringer ved periodeslutt',
  'rco.check.roundAmounts': 'Runde beløp',
});
